import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../general.service';
import { DataService } from '../data.service';

@Component({
  selector: 'app-sync',
  templateUrl: './sync.component.html',
  styleUrls: ['./sync.component.scss']
})
export class SyncComponent implements OnInit {

  public downloaded = false;
  public uploaded = false;

  constructor(
    public generalSvc: GeneralService,
    public dataSvc: DataService
  ) {
    // 
  }

  ngOnInit() {

  }

  continueLogin(){

  }
}